import { render, staticRenderFns } from "./Accept.vue?vue&type=template&id=79cdeb14&scoped=true"
import script from "./Accept.vue?vue&type=script&lang=ts"
export * from "./Accept.vue?vue&type=script&lang=ts"
import style0 from "./Accept.vue?vue&type=style&index=0&id=79cdeb14&prod&lang=scss&scoped=true"
import style1 from "./Accept.vue?vue&type=style&index=1&id=79cdeb14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cdeb14",
  null
  
)

export default component.exports